import { render, staticRenderFns } from "./Error460.vue?vue&type=template&id=12e169d6&"
import script from "./Error460.vue?vue&type=script&lang=js&"
export * from "./Error460.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports